export interface fileUploadSizeDTO {
  maxFileSize: number;
  maxHeight: number;
  maxWidth: number;
}

export const ONE_MB = 1048576;
export const TEN_MB = 10485760;
export const ALLOWED_SHEET_FORMAT = ['xls', 'xlsx', 'xlsb'];
export const ALLOWED_IMG_FORMAT = ['image/jpg', 'image/png', 'image/jpeg', 'application/pdf'];

export const DEFAULT_SIZE: fileUploadSizeDTO = {
  maxFileSize: TEN_MB,
  maxHeight: 200000,
  maxWidth: 200000,
};

export const MAIN_LOGO_SIZE: fileUploadSizeDTO = {
  maxFileSize: ONE_MB,
  maxHeight: 260,
  maxWidth: 650,
};

export const DISCONNECTED_LOGO_SIZE: fileUploadSizeDTO = {
  maxFileSize: ONE_MB,
  maxHeight: 250,
  maxWidth: 650,
};

export const SPLASH_LOGO_SIZE: fileUploadSizeDTO = {
  maxFileSize: ONE_MB,
  maxHeight: 800,
  maxWidth: 1500,
};
